import React from "react";

// Data
import { serviceCards__data } from "../../components/editComponents/cards/cardsData";
import ReviewCard from "../../components/cards/reviewCards/ReviewCard/ReviewCard";
import { reviews__data } from "../../components/editComponents/cards/data_reviews";
// Images
import RandomImg from "../../assets/images/home/pricing.jpg";

// Components

import AllCards from "../../components/cards/AllCards";
import CardsContainer from "../../components/containers/CardsContainer/CardsContainer";
import HeroSection from "../../components/otherComponents/HeroSection/HeroBanner";

import ImageCard from "../../components/cards/ImageCard/ImageCard";
import CenterItemsContainer from "../../components/containers/CenterItemsContainer/CenterItemsContainer";

function HomePage() {
  return (
    <div>
      <HeroSection />

      <CardsContainer
        scroll={true}
        marginTop={60}
        gapBetween={10}
        title={"Services"}
        titlePosition={"Center"}
      >
        {serviceCards__data.cards.map((card, index) => {
          return <AllCards card={card} card__data={serviceCards__data} />;
        })}
      </CardsContainer>

      <CardsContainer
        title="Reviews"
        gapBetween={15}
        marginTop={60}
        marginBottom={60}
      >
        {reviews__data.reviews.map((review, index) => {
          return <ReviewCard data={review} key={index} />;
        })}
      </CardsContainer>

      <CenterItemsContainer marginBottom={60}>
        <ImageCard
          src={RandomImg}
          width={"95%"}
          height={"95%"}
          maxHeight={400}
          maxWidth={400}
          borderRadius={7}
          border={"1px solid gray"}
        />
      </CenterItemsContainer>
    </div>
  );
}

export default HomePage;
